import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-placeholder-card',
    templateUrl: './placeholder-card.component.html',
    styleUrls: ['./placeholder-card.component.css'],
    standalone: true
})
export class PlaceholderCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
